module.exports = __webpack_public_path__ + "static/media/defaultDestination.8d1666a8.jpg";